import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { playerWager } from './playerWager.js';

export const wagerResponseSchema = z
  .object({
    wager: playerWager,
  })
  .transform(({ wager }) => ({ data: wager }));

export const wagerApiResponse = {
  parse: (data: unknown) => z.union([wagerResponseSchema, apiErrorSchema]).parse(data),
} as const;
